import {useEffect, useState} from "react";

import {withCache} from "../cache";
import {useApi} from "../PlayMakersProvider";
import {User} from "../types";

type FetchUserMethod = (quiet?: boolean) => Promise<User>;

interface UseUserReturn {
  refresh: FetchUserMethod;
  fetched: boolean;
  user: User | null;
}

export const useUser = (userId: string): UseUserReturn => {
  const {getUser} = useApi();

  const [fetched, setFetched] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);


  const fetchUser: FetchUserMethod = async(quiet: boolean = false) => {
    setFetched(quiet);
    try {
      const user = await withCache(getUser, [userId], 60_000);
      setUser(user);
      return user;
    } catch (error) {
      console.error("Error fetching user", userId, error);
      throw new Error(`Error fetching user '${userId}'`, {
        cause: error
      });
    } finally {
      setFetched(true);
    }
  };

  useEffect(() => {
    if(userId) fetchUser();
  }, [userId]);

  return {
    fetched,
    refresh: fetchUser,
    user
  };
};
